<!-- TODO need refactor -->
<template>
  <b-modal hide-footer size="lg" v-model="show">
    <Preloader v-if="showPreloader && isLoading" />
    <template v-slot:modal-header="{ cancel }">
      <h5 class="modal-title">Create expense</h5>
      <button
        @click.prevent="cancel"
        aria-label="Close"
        class="close"
        type="button"
      >
        <span class="material-icons">
          close
        </span>
      </button>
    </template>
    <b-form @submit.prevent="submit" @reset="onReset">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="container">
            <div class="row">
              <div class="col-12 px-0 form-group">
                <label class="form__label">Category*</label>
                <multiselect
                  v-model="form.expenses_category"
                  :options="expensesCategories"
                  placeholder="Category"
                  track-by="id"
                  label="display_name"
                  :allow-empty="false"
                  :showLabels="false"
                  @select="selectCategory"
                />
                <div class="form-generator__error" v-show="$v.$dirty && !$v.form.expenses_category.required">
                  Category is required
                </div>
              </div>
              <div class="col-12 px-0 form-group">
                <label class="form__label">Amount*</label>
                <b-form-input placeholder="amount" v-model="form.amount" />
                <div class="form-generator__error" v-show="$v.$dirty && !$v.form.amount.required">
                  Amount is required
                </div>
              </div>
              <div class="col-12 px-0 form-group">
                <label class="form__label">Bank card*</label>
                <multiselect
                  v-model="form.bank_card"
                  :disabled="!!form.bank_detail"
                  :options="bankCards"
                  placeholder="Bank card"
                  track-by="id"
                  label="name"
                  :allow-empty="true"
                  :showLabels="false"
                />
                <div v-if="!!form.bank_detail"><sup>To enable unselect "Bank account" clicking on it's selected option</sup></div>
                <div class="form-generator__error" v-show="$v.$dirty && !$v.form.bank_card.required">
                  Bank card is required
                </div>
              </div>
              <div class="col-12 px-0 form-group">
                <label class="form__label">Invoice File</label>
                <b-form-file
                  v-model="form.receipt_file"
                  ref="receiptFile"
                  placeholder="Choose a invoice file"
                  drop-placeholder="Drop file here..."
                  class="invoice-file"
                ></b-form-file>
              </div>
               <div class="col-12 px-0 form-group">
              <label class="form__label">Project</label>
              <multiselect
                v-model="form.related_project"
                :options="projects"
                :disabled="!form.expenses_category || !form.expenses_category.is_project_related"
                placeholder="Project"
                track-by="id"
                label="label"
                :allow-empty="false"
                :showLabels="false"
              />
              <div class="form-generator__error" v-show="$v.$dirty && !$v.form.related_project.required">
                Project is required
              </div>
            </div>

            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="container">
            <div class="row">
              <div class="col-12 px-0 form-group">
                <label class="form__label">Status*</label>
                <multiselect
                  v-model="form.expenses_status"
                  :options="expensesStatuses"
                  placeholder="Choose status"
                  track-by="id"
                  label="display_name"
                  :allow-empty="false"
                  :showLabels="false"
                />
                <div class="form-generator__error" v-show="$v.$dirty && !$v.form.expenses_status.required">
                  Expenses status is required
                </div>
              </div>
              <div class="col-12 px-0 form-group">
                <label class="form__label">Currency*</label>
                <multiselect
                  v-model="form.currency"
                  :options="currencies"
                  placeholder="Select"
                  track-by="id"
                  label="code"
                  :allow-empty="false"
                  :showLabels="false"
                />
                <div class="form-generator__error" v-show="$v.$dirty && !$v.form.currency.required">
                  Currency is required
                </div>
              </div>
              <div class="col-12 px-0 form-group">
                <label class="form__label">Bank account*</label>
                <multiselect
                  v-model="form.bank_detail"
                  :disabled="!!form.bank_card"
                  :options="ownBankDetails"
                  placeholder="Bank account"
                  track-by="id"
                  label="summary"
                  :allow-empty="true"
                  :showLabels="false"
                />
                <div v-if="!!form.bank_card"><sup>To enable unselect "Bank card" clicking on it's selected option</sup></div>
                <div class="form-generator__error" v-show="$v.$dirty && !$v.form.bank_detail.required">
                  Bank card is required
                </div>
              </div>
              <div class="col-12 px-0 form-group">
                <label class="form__label">Uploaded invoice file url</label>
                <b-form-input
                  placeholder="Invoice url"
                  v-model="form.invoice_url"
                />
              </div>
              <div class="col-12 px-0 form-group">
              <label class="form__label">User</label>
              <multiselect
                v-model="form.user"
                :options="users"
                placeholder="User"
                track-by="id"
                label="label"
                :allow-empty="false"
                :showLabels="false"
              />
            </div>
            </div>
          </div>
        </div>
      </div>

      <b-form-group>
        <label class="form__label">Comment*</label>
        <b-form-textarea
          id="textarea"
          v-model="form.comment"
          placeholder="Enter comment"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
        <div class="form-generator__error" v-show="$v.$dirty && !$v.form.comment.required">
          Comment is required
        </div>
      </b-form-group>

      <div class="row">
        <div class="col-12 col-md-6 form-group">
          <label class="form__label">Due date*</label>
          <datepicker
            placeholder="Due date"
            :value="_toIsoStringTime(form.due_date)"
            @input="form.due_date = _toLocalTime($event)"
            :format="dateFormat"
            :bootstrap-styling="true"
          />
          <div class="form-generator__error" v-show="$v.$dirty && !$v.form.due_date.required">
            Due date card is required
          </div>
        </div>

        <div class="col-12 col-md-6 form-group">
          <label class="form__label">Paid date (if status "paid")</label>
          <datepicker
            :disabled="
              form.expenses_status !== null &&
              form.expenses_status !== undefined &&
              form.expenses_status.name !== 'paid'
            "
            placeholder="Paid date"
            :value="_toIsoStringTime(form.paid_date)"
            @input="form.paid_date = _toLocalTime($event)"
            :format="dateFormat"
            :bootstrap-styling="true"
          />
        </div>
      </div>

      <b-form-group v-if="edit">
        <!-- <b-button @click="close" variant="danger">Close</b-button> -->
        <b-button
          type="submit"
          :disabled="isButtonDisabled"
          variant="primary"
          class="ml-auto button"
        >
          Edit
        </b-button>
      </b-form-group>
      <b-form-group v-else>
        <div class="d-flex">
          <b-button variant="outline" class="ml-auto button" type="reset">
            Reset
          </b-button>
          <b-button
            type="submit"
            variant="primary"
            class="ml-2 button"
          >
            Create
          </b-button>
        </div>
      </b-form-group>
    </b-form>
  </b-modal>

</template>

<script>
  import {cloneDeep} from 'lodash'
  import Preloader from '@/components/Preloader.vue'
  import Datepicker from 'vuejs-datepicker'
  import {mapGetters} from 'vuex'
  import {validationMixin} from 'vuelidate'

  const { required, requiredIf } = require('vuelidate/lib/validators')

export default {
  name: 'FinancesExpensesForm',
  mixins: [validationMixin],
  components: { Preloader, Datepicker },
  data () {
    return {
      form: {
        expenses_category: null,
        related_project: null,
        expenses_status: null,
        amount: null,
        currency: null,
        bank_card: null,
        bank_detail: null,
        receipt_file: null,
        invoice_url: null,
        comment: null,
        due_date: '',
        paid_date: '',
        user: null
      }
    }
  },
  validations: {
    form: {
      expenses_category: { required },
      related_project: {
        required: requiredIf(function (item) {
          return this.form.expenses_category && this.form.expenses_category.is_project_related
        })
      },
      expenses_status: { required },
      amount: { required },
      currency: { required },
      bank_card: { required: requiredIf(function (item) {
        return !this.form.bank_detail
      }) },
      bank_detail: { required: requiredIf(function (item) {
        return !this.form.bank_card
      }) },
      comment: { required },
      due_date: { required }
    }
  },
  props: {
    edit: {
      type: Boolean,
      default: () => false
    },
    title: {
      type: String
    },
    dataProps: {
      type: Object,
      default: () => {}
    },
    expensesCategories: {
      type: Array
    },
    projects: {
      type: Array
    },
    expensesStatuses: {
      type: Array
    },
    currencies: {
      type: Array
    },
    users: {
      type: Array
    },
    bankCards: {
      type: Array
    },
    ownBankDetails: {
      type: Array
    },
    isLoading: {
      type: Boolean,
      default: () => false
    },
    showPreloader: {
      type: Boolean,
      default: () => false
    },
    value: {
      type: Boolean
    }
  },
  mounted () {
    if (this.dataProps) {
      this.setData()
    }

    if (!this.edit) {
      this.setDefaultUser()
      this.getDefaultValueForStatus()
      if (!this.form.currency) {
        this.getDefaultValueForCurrency()
      }
    }
  },
  watch: {
    dataProps: function value (val) {
      this.setData()
    }
  },
  computed: {
    ...mapGetters({
      dateFormat: 'dateFormat',
      getUser: 'getUser'
    }),
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    isButtonDisabled () {
      // eslint-disable-next-line
      return (
        !this.form.amount ||
        !this.form.expenses_category ||
        (this.form.expenses_category &&
          this.form.expenses_category.is_project_related &&
          !this.form.related_project) ||
        !(this.form.bank_card || this.form.bank_detail) ||
        !this.form.currency ||
        !this.form.due_date ||
        !this.form.expenses_status ||
        !(
          this.form.expenses_status.name !== 'paid' ||
          (this.form.expenses_status.name === 'paid' && this.form.due_date)
        ) ||
        !this.form.comment ||
        this.isLoading
      )
    }
  },
  methods: {
    selectCategory (category) {
      if (!category.is_project_related) {
        this.form.related_project = null
      }
    },
    getDefaultValueForStatus () {
      this.form.expenses_status = this.expensesStatuses.find(item => item.name === 'paid')
    },
    getDefaultValueForCurrency () {
      this.form.currency = this.currencies.find(item => item.code === 'UAH')
    },
    setDefaultUser () {
      this.form.user = this.getUser
    },
    setData () {
      this.form.amount = this.dataProps.amount

      this.form.expenses_category = this.expensesCategories.find(
        (item) => item.id === this.dataProps.expenses_category_id
      )

      this.form.related_project = this.projects.find(
        (item) => item.id === this.dataProps.related_project_id
      )

      this.form.user = this.users.find(
        (item) => item.id === this.dataProps.user_id
      )

      this.form.expenses_status = this.expensesStatuses.find(
        (item) => item.id === this.dataProps.expenses_status_id
      )

      this.form.currency = this.currencies.find(
        (item) => item.id === this.dataProps.currency_id
      )

      this.form.bank_card = this.bankCards.find(
        (item) => item.id === this.dataProps.bank_card_id
      )

      this.form.bank_detail = this.ownBankDetails.find(
        (item) => item.id === this.dataProps.bank_detail_id
      )

      this.form.invoice_url =
        this.dataProps.invoice_url == null ? '' : this.dataProps.invoice_url
      this.form.comment = this.dataProps.comment
      this.form.due_date = !this.dataProps.due_date ? '' : this._toLocalTime(this.dataProps.due_date)
      this.form.paid_date = !this.dataProps.paid_date ? '' : this._toLocalTime(this.dataProps.paid_date)
    },
    onReset (evt) {
      if (evt) {
        evt.preventDefault()
      }

      /* Reset our form values */
      for (let key in this.form) {
        this.form[key] = ''
      }
      /* Trick to reset/clear native browser form validation state */
      this.$nextTick(() => {
        this.show = true
      })
    },
    close () {
      this.$emit('close')
      this.onReset()
    },
    async submit () {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return false
      }
      if (this.isButtonDisabled) {
        return
      }

      let data = cloneDeep(this.form)
      if (this.form.receipt_file) {
        const receiptFileBase64 = await this.fileToBase64(this.$refs['receiptFile'].value)
        data['receipt_file'] = receiptFileBase64
      }
      this.$emit('submit', data)
    }
  }
}
</script>

<style lang="scss">
.custom-form {
  position: relative;
  padding: 20px 30px;
}
.preloader {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 10;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.7);
}
.invoice-file {
  .custom-file-label {
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 81px;
    display: block;
  }
}
</style>
